import DatabaseAdvancedForm from './DatabaseAdvancedForm'

export default DatabaseAdvancedForm
